import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Dialog, useTheme } from '@mui/material';
import warning from 'assets/icons/warning.svg';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IStore } from 'v3/data/store';
import { setErrorConnectionState } from 'v3/data/store/error/actions';
import { useHandleOnExitClick } from 'v3/hooks/useHandleOnExitClick';
import { GO_BACK } from 'v3/routes/enum';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { BodyLarge } from 'v3/shared/typography/BodyLarge';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { Body, Container, Image, Info, PaperStyled, TextAlign, TextGroup } from './styles';

export const ConnectionError = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { handleOnExitClick } = useHandleOnExitClick();
  const { error } = useSelector((state: IStore) => state.error.connectionState);
  const handleOnTryAgainClick = () => {
    navigate(GO_BACK);
    setErrorConnectionState();
  };

  return (
    <Dialog
      onClose={setErrorConnectionState}
      open={error}
      fullScreen={true}
      transitionDuration={0}
      PaperComponent={PaperStyled}
    >
      <Container>
        <Body>
          <Image src={warning} alt={'warning'} />
          <HeadlineMedium color={theme.palette.common.white}>Opa, erro de conexão</HeadlineMedium>

          <Info>
            <BodyLarge>Enquanto isso, você pode tentar:</BodyLarge>
            <TextAlign>
              <RestartAltIcon />
              <SubtitleLarge>Reiniciar a página</SubtitleLarge>
            </TextAlign>
            <TextAlign>
              <AccessTimeIcon />
              <SubtitleLarge>Tentar novamente em 20 minutos.</SubtitleLarge>
            </TextAlign>
          </Info>

          <TextGroup>
            <SubtitleLarge>Entre em contato conosco através dos números:</SubtitleLarge>
            <SubtitleLarge>+55 (11) 5196-8374 (WhatsApp).</SubtitleLarge>
          </TextGroup>

          <TextGroup>
            <SubtitleLarge>Horários de atendimento:</SubtitleLarge>
            <SubtitleLarge>Segunda a sábado, das 09 às 21hrs (Horário de Brasília)</SubtitleLarge>
            <SubtitleLarge>Domingo e feriados sem expediente</SubtitleLarge>
          </TextGroup>

          <FlexButton
            data-testid="flex-button-check-info"
            text="Revisar informações"
            handleClick={handleOnTryAgainClick}
          />
          <TextButton data-testid="text-button-out" text="Sair" handleClick={handleOnExitClick} />
        </Body>
      </Container>
    </Dialog>
  );
};
